import { createStitches } from '@stitches/react';
import theme from './stitches.config.theme';
import utils from './stitches.utils.config';

export const { styled, getCssText, globalCss, createTheme, css, keyframes } =
  createStitches({
    // prefix: 'v',
    media: {
      xs: '(min-width: 480px)',
      sm: '(min-width: 640px)',
      md: '(min-width: 768px)',
      lg: '(min-width: 1024px)',
      xl: '(min-width: 1280px)',
      xxl: '(min-width: 1536px)',
    },
    theme,
    utils,
  });

export const darkTheme = createTheme({
  colors: {
    // preview
    brand:
      'hsl( $brand-hue calc($brand-saturation/2) calc($brand-lightness/1.5) )',
    text1: 'hsl( $brand-hue 15% 85% )',
    text2: 'hsl( $brand-hue 5% 65% )',
    surface1: 'hsl($brand-hue 10% 10%)',
    surface2: 'hsl($brand-hue 10% 15%)',
    surface3: 'hsl($brand-hue 5% 20%)',
    surface4: 'hsl($brand-hue 5% 25%)',

    primary: '255, 255, 255',

    text: '255, 255, 255',
    background: '0,0,0',
    hover: '240,240,240',
  },
  shadows: {
    // preview
    surface: '$colors$brand-hue 50% 3%',
    strength: 0.8,
    rad: `0 2.8px 2.2px hsl($surface / calc($strength + .03)),
    0 6.7px 5.3px hsl($surface / calc($strength + .01)),
    0 12.5px 10px hsl($surface / calc($strength + .02)),
    0 22.3px 17.9px hsl($surface / calc($strength + .02)),
    0 41.8px 33.4px hsl($surface / calc($strength + .03)),
    0 100px 80px hsl($surface / $strength)`,

    icon: '0 1px 3px 0 rgb(255,255,255, 0.2)',
  },
});

export const dimTheme = createTheme({
  colors: {
    // preview
    brand:
      'hsl( $brand-hue calc($brand-saturation/1.25) calc($brand-lightness/1.25) )',
    text1: 'hsl( $brand-hue 15% 75% )',
    text2: 'hsl( $brand-hue 10% 61% )',
    surface1: 'hsl($brand-hue 10% 25%)',
    surface2: 'hsl($brand-hue 5% 30%)',
    surface3: 'hsl($brand-hue 10% 20%)',
    surface4: 'hsl($brand-hue 5% 35%)',
    mask: '#ffffff',
  },
  shadows: {
    // preview
    shadow: '$colors$brand-hue 30% 13%',
    strength: 0.2,
  },
});
